import { create, JSSPlugin } from 'jss';
import { MuiThemeProvider } from '@material-ui/core';
import { createGenerateClassName, jssPreset } from '@material-ui/styles';
import { observer } from 'mobx-react';
import * as React from 'react';
import JssProvider from 'react-jss/lib/JssProvider';
import { Router, Route } from 'react-router';
import { RouteComponentProps } from 'react-router-dom';

import { lazyInject } from './ioc';
import { AnalyticsStore } from './core/stores/analytics.store';
import { ClientDataStore } from './core/stores/client-data.store';
import { RouterStore } from './core/stores/router.store';
import { ContactUsDialog } from './core/components/contact-us-dialog/contact-us-dialog';
import { AppRoutes } from './routes';
import { theme } from './util/mui-theme';
import { ScrollToTop } from './util/scroll-to-top';

import { PageHeaderContainer } from './core/components/page-header/page-header';



import './assets/less/styles-desktop.less';
import './util/interceptors';

const generateClassName = createGenerateClassName({
    disableGlobal: true,
    productionPrefix: 'mat',
});
const jssOptions = jssPreset();
jssOptions.insertionPoint = document.getElementById('jss-insertion-point')!;
const jss = create({
    plugins: [...(jssPreset().plugins as JSSPlugin[])],
});

@observer
export class MainApp extends React.Component {
    @lazyInject(AnalyticsStore) private analytics!: AnalyticsStore;
    @lazyInject(ClientDataStore) private clientData!: ClientDataStore;
    @lazyInject(RouterStore) private router!: RouterStore;

    constructor(props: {}) {
        super(props);
        this.clientData.init();
        document.getElementById('app-root')!.className = 'desktop-view';
        if (this.clientData.isAnonymousPayments || this.clientData.isAnonymousEstimates) {
            document.getElementById('app-root')!.className += ' anonymous-payments';
        }
    }

    handleRouteChange = (props: RouteComponentProps<{}>) => {
        this.router.location = props.location;

        const shortenedPath = props.location.pathname.replace(/\/0[0-9a-f][0-9a-zA-Z_-]+/g, '');
        this.analytics.viewPage(shortenedPath);

        return null;
    };

    render() {
        return (
            <JssProvider jss={jss} generateClassName={generateClassName}>
                <MuiThemeProvider theme={theme}>
                    <Router history={this.router.history}>
                        <React.Fragment>
                            <Route render={this.handleRouteChange} />
                            {}
                            {this.clientData.isInitialized || !!this.clientData.initError ? (
                                <React.Fragment>
                                    {}
                                    <Route component={PageHeaderContainer} />
                                    {}
                                    {}
                                        <Route component={AppRoutes} />
                                        {}
                                </React.Fragment>
                            ) : null}
                            <ScrollToTop />
                        </React.Fragment>
                    </Router>
                    <ContactUsDialog />
                </MuiThemeProvider>
            </JssProvider>
        );
    }
}
